module.exports = __webpack_public_path__ + "img/ic_danger.ecb3d0f9.svg";